module.exports = __webpack_public_path__ + "img/google-color.48ce3cd9.svg";